require('/opt/odin/app/frontend/components/filter_suggestions/index.module.scss');module.exports = "../../app/cells/components/filter_suggestions/show.erb";